/* eslint-disable */
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { isScreenLarge } from './utils/screen-size';

const hasSomeParentTheClass = (elem, className): HTMLElement => {
  if (elem) {
    if (
      elem.className &&
      typeof elem.className === 'string' &&
      elem.className.split(' ').indexOf(className) >= 0
    ) {
      return elem;
    }
    return (
      elem.parentElement && hasSomeParentTheClass(elem.parentElement, className)
    );
  }
};

export enum EventType {
  LOGOUT = 'logout',
}

export const CustomEvents = {
  drawer_open_navi: () => {
    const html = document.querySelector<HTMLElement>('html');
    html && html.classList.add('with-header-nav-contrast');
    document.querySelector<HTMLElement>('.drawer-navi').classList.add('active');
    const selector = '#site-drawer-navi';
    const target = document.querySelector<HTMLElement>(selector);
    if (target) {
      target.focus();
    } else {
      console.error(`Unable to find focus target ${selector}`);
    }
  },
  drawer_close: () => {
    const html = document.querySelector<HTMLElement>('html');
    html && html.classList.remove('with-drawer');
    html && html.classList.remove('with-header-nav-contrast');
    document.querySelectorAll('.site-drawer').forEach((v) => {
      v.classList.remove('active');
    });
    setTimeout(() => {
      const activeExpand = document.querySelector<HTMLElement>(
        '.drawer-navi .expander.active',
      );
      if (activeExpand) activeExpand.classList.remove('active');
      const firstExpander = document.querySelector<HTMLElement>(
        '.drawer-navi .section.s1 .item:first-child .expander',
      );
      if (firstExpander) {
        firstExpander.classList.add('active');
      }
    }, 500);
    // unable to restore focus
    // use the drawer_close_navi if you want to restore focus
  },
  drawer_close_navi: () => {
    const html = document.querySelector<HTMLElement>('html');
    html && html.classList.remove('with-drawer');
    html && html.classList.remove('with-header-nav-contrast');
    document.querySelectorAll('.site-drawer').forEach((v) => {
      v.classList.remove('active');
    });
    setTimeout(() => {
      const activeExpand = document.querySelector<HTMLElement>(
        '.drawer-navi .expander.active',
      );
      if (activeExpand) {
        activeExpand.classList.remove('active');
      }
      const firstExpander = document.querySelector<HTMLElement>(
        '.drawer-navi .section.s1 .item:first-child .expander',
      );
      if (firstExpander) {
        firstExpander.classList.add('active');
      }
    }, 500);
    // restore focus
    const selector = '#site-mobnav-toggle';
    const target = document.querySelector<HTMLElement>(selector);
    if (target) {
      target.focus();
    } else {
      console.error(`Unable to restore focus to ${selector}`);
    }
  },
  expand: (target: HTMLElement, forceOpen?: boolean) => {
    const trigger = target && target.parentElement;
    if (trigger && trigger.classList.value.includes('expander')) {
      document.querySelectorAll<HTMLElement>('.expander').forEach((v) => {
        if (v !== trigger) {
          v?.querySelector<HTMLElement>('.head')?.removeAttribute('style');
          v.classList.remove('active');
          v.removeAttribute('style');
          const vbody = v.querySelector<HTMLElement>('.body');
          if (vbody) vbody.removeAttribute('style');
        }
      });

      if (forceOpen) {
        trigger.classList.toggle('active', true);
      } else {
        trigger.classList.toggle('active');
      }
      const head = trigger.querySelector<HTMLElement>('.head');
      const headHeight = (head && head.offsetHeight) || 0;
      const isWithHeadTh = trigger.classList.contains('with-head-th');
      const isActive = trigger.classList.contains('active');

      trigger.setAttribute('aria-expanded', isActive.toString());

      const body = trigger.querySelector<HTMLElement>('.body');
      if (isActive) {
        if (isWithHeadTh && isScreenLarge()) {
          trigger.querySelector<HTMLElement>('.head').style.marginBottom = `-${
            headHeight - 1
          }px`;
        }
        if (body) {
          body.style.maxHeight =
            body.querySelector<HTMLElement>('.container').offsetHeight + 'px';
        }
        if (body && window.location.pathname.includes('reference')) {
          body.style.maxHeight =
            body.querySelector<HTMLElement>('.container').offsetHeight +
            headHeight +
            'px';
        }
      } else {
        if (body) body.removeAttribute('style');

        if (isWithHeadTh && isScreenLarge()) {
          trigger.querySelector<HTMLElement>('.head').removeAttribute('style');
        }
      }
    }
  },
  form_cart_error: (e) => {
    const drawer = document.querySelector<HTMLElement>('.site-drawer.active');
    if (drawer) drawer.scrollTop = drawer.scrollHeight;
  },
  form_checkout_error: (e) => {
    const page = document.querySelector<HTMLElement>('.page-checkout');
    if (page) page.scrollTop = page.scrollHeight / 10;
  },
  toggle_account_subscription_form: (e) => {
    const container: HTMLElement =
      e.detail.currentTarget.parentNode.parentNode.parentNode;
    const elements = [
      container.querySelector<HTMLElement>('.button-popup-cancel'),
      container.querySelector<HTMLElement>('.form-account-promo-code'),
    ];
    elements.forEach((element) => {
      element && element.classList.toggle('edit');
    });
  },
  popup_open: (e) => {
    const id = e.detail;
    const data = e.data;
    const siteHtml = document.querySelector<HTMLElement>('html');
    const sitePopup = document.querySelector<HTMLElement>('#' + id);
    const siteButton = document.querySelector<HTMLElement>(
      '[data-id=' + id + ']',
    );

    window.seed_popup_id = id;

    if (data) window.seed_popup = data;
    siteHtml && siteHtml.classList.add('with-popup');
    if (sitePopup) {
      sitePopup.classList.add('active');
    }
    siteButton && siteButton.classList.add('active');
    if (isScreenLarge()) {
      disableBodyScroll(sitePopup, { reserveScrollBarGap: true });
    } else {
      if (sitePopup?.classList.contains('site-popup-drawer')) {
        siteHtml.classList.add('overflow-hidden');
      }
    }

    setTimeout(() => {
      if (!sitePopup) return;
      // focus on the close button

      sitePopup.querySelector<HTMLElement>('button, *[tabindex]').focus();
    }, 500);
  },
  popup_close: (e) => {
    const id = e.detail;

    if (window.seed_popup) delete window.seed_popup;
    const siteHtml = document.querySelector<HTMLElement>('html');
    const sitePopup = document.querySelector<HTMLElement>('#' + id);
    const siteButton = document.querySelector<HTMLElement>(
      '[data-id=' + id + ']',
    );
    sitePopup && sitePopup.classList.add('animation-out');
    siteHtml && siteHtml.classList.add('pop-up-out');
    siteButton && siteButton.classList.remove('active');
    if (window.innerWidth > 480) {
      enableBodyScroll(sitePopup, { reserveScrollBarGap: true });
    }
    setTimeout(() => {
      siteHtml && siteHtml.classList.remove('with-popup');
      sitePopup && sitePopup.classList.remove('active', 'animation-out');
      siteHtml.classList.remove('overflow-hidden');
      siteHtml.classList.remove('pop-up-out');

      const selector = `#popup-source-button-${id}`;
      const target = document.querySelector<HTMLElement>(selector);
      if (target) {
        // restore focus to the originating button (if possible)

        target.focus();
      }
    }, 500);
  },
};

const EventHandlers = {
  Load() {
    // window.scrollTo(0,0);
  },
  Click(e) {
    const target = hasSomeParentTheClass(e.target, 'expand');

    CustomEvents.expand(target);
  },
  Enter(e) {
    if (e.keyCode !== 13) {
      return;
    }

    const target = hasSomeParentTheClass(e.target, 'expand');

    CustomEvents.expand(target);
  },
  FocusIn(e) {
    // Open accordion if they tab to a link inside it
    if (
      !(e.target instanceof Element) ||
      !e.target.closest('[data-accordion-body]')
    ) {
      return;
    }
    const target = hasSomeParentTheClass(e.target, 'expander');
    if (target) {
      const expand = target.querySelector<HTMLElement>('.expand');
      if (expand) {
        CustomEvents.expand(expand, true);
      }
    }
  },
  Scroll() {
    const siteHtmlEl = document.querySelector<HTMLElement>('html');

    let scrollTrigger = 250;

    if (siteHtmlEl.classList.contains('scrolled-long-mobile')) {
      if (window.innerWidth < 1000) {
        scrollTrigger = window.innerHeight * 0.85;
      }
    }

    if (window.scrollY > 10) {
      siteHtmlEl.classList.add('with-little-scrolled');
    } else {
      siteHtmlEl.classList.remove('with-little-scrolled');
    }

    if (window.location.href.includes('daily-synbiotic')) {
      scrollTrigger = window.innerHeight * 1.05;
    }

    if (window.scrollY > scrollTrigger) {
      siteHtmlEl.classList.add('with-scrolled');
    } else {
      siteHtmlEl.classList.remove('with-scrolled');
    }
  },
  Resize() {
    const myEvent = new CustomEvent('site_resize');
    window.dispatchEvent(myEvent);
  },
};

const EventListeners = {
  Load() {
    window.addEventListener('load', EventHandlers.Load);
    this.Resize();
    this.Scroll();
    this.Click();
    this.Enter();
    this.Escape();
    this.FocusIn();
    for (const key in CustomEvents) {
      window.addEventListener(key, (e) => {
        CustomEvents[key](e);
      });
    }
  },
  Click() {
    document.addEventListener('click', EventHandlers.Click);
  },
  Enter() {
    document.addEventListener('keyup', EventHandlers.Enter);
  },
  Escape() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && window.seed_popup_id) {
        CustomEvents.popup_close({
          detail: window.seed_popup_id,
        });
      }
    });
  },
  FocusIn() {
    document.addEventListener('focusin', EventHandlers.FocusIn);
  },
  Scroll() {
    window.addEventListener('scroll', EventHandlers.Scroll);
  },
  Resize() {
    let resize;
    window.onresize = () => {
      clearTimeout(resize);
      resize = setTimeout(EventHandlers.Resize, 250);
    };
  },
};

export default EventListeners;
